import { Injectable, TemplateRef } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ToastService {
  toasts: any[] = [];

  show(
    textOrTpl: string | TemplateRef<any>,
    header: string,
    options: any = {}
  ) {
    this.toasts.push({ textOrTpl, header, ...options });
  }

  remove(toast) {
    this.toasts = this.toasts.filter((t) => t !== toast);
  }
}
